export default "__VITE_ASSET__ChEyx3FT__"